import { Container, Box } from '@mui/material';
import { ReactNode } from 'react';

type ModalFullScreenContentProps = {
  children?: ReactNode;
  safeAreaBottomDisabled?: boolean;
};

export const ModalFullScreenContent = (props: ModalFullScreenContentProps) => {
  const { children, safeAreaBottomDisabled = false } = props;
  return (
    /* Scroll container wraps a centered Container so scrolling happens here, not on the Container inside
     * It allows us display scroll bar at the edge of the page and not inside Container content */
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: 1,
        minHeight: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
      }}>
      <Container
        disableGutters
        maxWidth="sm"
        sx={{
          flex: 1,
          px: 0, // MUI bug: disableGutters doesn't fully remove padding — override manually
          paddingBottom: safeAreaBottomDisabled ? 0 : 'var(--ion-safe-area-bottom, 0px)',
        }}>
        {children}
      </Container>
    </Box>
  );
};
